import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { Grid, Typography } from '@material-ui/core'
import { RouteComponentProps, withRouter } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { NewsCriteria } from 'src/type/criteria/newsCriteria'
import { fetchNews, fetchMoreNews } from 'src/core/redux/action/newsAction'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import autobind from 'autobind-decorator'
import PublicNewsCard from 'src/page/PublicNews/PublicNewsCard'

const paginateName = 'news';
const paginateAction = fetchNews;
const actions = new PaginateAction<any>(paginateName, paginateAction)

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  dispatch: any;
}

const MAPPING_CATEGORY = {
    "change": "principale",
    "dette": "principale",
    "placement": "principale",
    "economique": "actu",
    "focus-actu": "actu",
    "perspectives": "actu",
    "pme-change": "actu",
    "pme-dette": "actu",
    "pme-placement": "actu",
    "points": "actu",
    "arkea": "actu",
    "hebdo-eco": "actu"
}

const FILTERS = {
    "partenaire-distributeur": [
        {label: "Focus Actu", value: "focus-actu"},
        {label: "Hebdo Eco", value: "hebdo-eco"},
        {label: "Perspectives eco", value: "perspectives"},
        {label: "Flash placement", value: "pme-placement"},
        {label: "Placement", value: "placement"},
    ],
    "entreprise-ou-institutionnel": [
        {label: "Change", value: "change"},
        {label: "Taux", value: "dette"},
        {label: "Placement", value: "placement"},
        {label: "Economique", value: "economique"},
        {label: "Focus Actu", value: "focus-actu"},
        {label: "Hebdo Eco", value: "hebdo-eco"},
        {label: "Perspectives eco", value: "perspectives"},
        {label: "Flash Change", value: "pme-change"},
        {label: "Flash dette", value: "pme-dette"},
        {label: "Flash placement", value: "pme-placement"},
        {label: "Tendances Marché", value: "points"},
        {label: "Autre", value: "arkea"},
    ]
}

const FILTER_SELECTED_DEFAULT = {
    "partenaire-distributeur": ["placement"],
    "entreprise-ou-institutionnel": ["economique"]
}

const FILTER_ISOLATED = {
    "partenaire-distributeur": ["placement"],
    "entreprise-ou-institutionnel": []
}


interface IState {
    filterSelected: string[]
}

class PublicNews extends React.Component<IProps, IState> {
  componentDidMount(){
    const {promisesWithProgress, updateObjectCriteria} = this.props
    promisesWithProgress(updateObjectCriteria({
        is_public: true,
        ...this.computeFilters(this.state.filterSelected)
    }))
  }

  state = {
    filterSelected: FILTER_SELECTED_DEFAULT[this.props.match.params.publicNewsType] || []
  }

  render() {
    const {t, news, totalSize, match} = this.props
    const publicNewsType = match.params.publicNewsType
    return (
        <>
            <section className="section__landing" style={{backgroundImage: "url('/assets/images/site/photo/news.jpg')"}}>
                <div className="section__content landing__text middle">
                    <h1 className="landing__title f-poppins">Découvrez nos actualités</h1>
                </div>
            </section>

            <section className="bg-white fullWidth space-arround-v-50">
                <div className="section__content">
                <h2 className="section__title f-poppins">Nos actualités et analyses économiques</h2>
                    <p className="text-bold f-poppins">Filtrer par catégories</p>
                    <div className="fl-container fl-wrap mg-t-1r mg-b-1r">
                        {this.filtersRendering(publicNewsType)}
                    </div>
                    <p className="clr-primary mg-t-1r mg-b-1r f-poppins">Nous vous invitons à prendre connaissance des informations concernant nos publications "Etudes économiques" dans les Disclaimers accessibles en bas de la page.</p>
                    <div>
                        {news && 
                            <Grid container>
                                {news.map(n => {
                                    return (
                                    <Grid item xs={12} md={3} key={`news-grid-${n.id}`}>
                                        <PublicNewsCard key={`news-${n.id}`} entity={n} newsType={publicNewsType}/>
                                    </Grid>
                                    )
                                })
                                }
                                {news.length < totalSize &&
                                <Grid item xs={12} style={{textAlign: "center"}}>
                                    <button
                                        className="btn-outline f-poppins"
                                        onClick={() => this.loadMoreNews(news.length)}
                                    >{t.load_more}</button>
                                </Grid>
                                }
                            </Grid>
                            }
                            {!news &&
                            <Grid container>
                                <Grid item xs={12}>
                                <Typography variant="body2" align="center" className="f-poppins">{t.news_no_post}</Typography>
                                </Grid>
                            </Grid>
                        }
                    </div>
                </div>
            </section>
            
            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-md-7 col-xs-12">
                            <h2 className="section__title f-poppins">Les économistes de la Salle</h2>
                            <p className="text-bold f-poppins">Au sein de la Salle des Marchés du Crédit Mutuel Arkéa, une équipe d’économistes spécialisés dans les marchés financiers assure une veille quotidienne du contexte macro-économique et publie des points marchés réguliers sous différents formats.</p>
                            <div className="fl-container fl-jc-around fullWidth mg-t-1r hidden-xs">
                                <div className="team-box">
                                    <img src="/assets/images/site/team/Paul_CHOLLET.png" alt="Paul CHOLLET" className="team__avatar" style={{width: "170px"}}/>
                                    <p className="team__name f-poppins">Paul CHOLLET</p>
                                    <a href="https://www.linkedin.com/in/paul-chollet-b4458a3b/">
                                        <img src="/assets/images/site/picto/linkedin.svg" alt="linkedin" className="team__sn-icon"/>
                                    </a>
                                </div>
                                <div className="team-box">
                                    <img src="/assets/images/site/team/Rodrigue_MEAR.png" alt="Rodrigue MEAR" className="team__avatar" style={{width: "170px"}}/>
                                    <p className="team__name f-poppins">Rodrigue MEAR</p>
                                    <a href="https://www.linkedin.com/in/rodrigue-mear-795875123/">
                                        <img src="/assets/images/site/picto/linkedin.svg" alt="linkedin" className="team__sn-icon"/>
                                    </a>
                                </div>
                                <div className="team-box">
                                    <img src="/assets/images/site/team/Julien_LECUMBERRY.png" alt="Julien LECUMBERRY" className="team__avatar" style={{width: "170px"}}/>
                                    <p className="team__name  f-poppins">Julien LECUMBERRY</p>
                                    <a href="https://www.linkedin.com/in/julien-lecumberry-72bb9a45/">
                                        <img src="/assets/images/site/picto/linkedin.svg" alt="linkedin" className="team__sn-icon"/>
                                    </a>
                                </div>
                            </div>
                            <div className="swiper-container swiper-team visible-xs">
                                <div className="swiper-wrapper">
                                    <div className="swiper-slide">
                                        <div className="team-box">
                                            <img src="/assets/images/site/team/Paul_CHOLLET.png" alt="Paul CHOLLET" className="team__avatar" style={{width: "170px"}}/>
                                            <p className="team__name f-poppins">Paul CHOLLET</p>
                                            <a href="https://www.linkedin.com/in/paul-chollet-b4458a3b/">
                                                <img src="/assets/images/site/picto/linkedin.svg" alt="linkedin" className="team__sn-icon"/>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="team-box">
                                            <img src="/assets/images/site/team/Rodrigue_MEAR.png" alt="Rodrigue MEAR" className="team__avatar" style={{width: "170px"}}/>
                                            <p className="team__name f-poppins">Rodrigue MEAR</p>
                                            <a href="https://www.linkedin.com/in/rodrigue-mear-795875123/">
                                                <img src="/assets/images/site/picto/linkedin.svg" alt="linkedin" className="team__sn-icon"/>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="swiper-slide">
                                        <div className="team-box">
                                            <img src="/assets/images/site/team/Julien_LECUMBERRY.png" alt="Julien LECUMBERRY" className="team__avatar" style={{width: "170px"}}/>
                                            <p className="team__name f-poppins">Julien LECUMBERRY</p>
                                            <a href="https://www.linkedin.com/in/julien-lecumberry-72bb9a45/">
                                                <img src="/assets/images/site/picto/linkedin.svg" alt="linkedin" className="team__sn-icon"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="swiper-button-prev"></div>
                                <div className="swiper-button-next"></div>
                            </div>
                        </div>
                        <div className="col-md-5"></div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-xs-12 text-center">
                            <img src="/assets/images/site/photo/signature.jpg" alt="" className="news-signature img-reponsive mg-t-5r"/>
                            <a href="mailto:sdm.strategie@arkea.com" className="tx-small f-poppins">sdm.strategie@arkea.com</a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
  }

  @autobind
  private filtersRendering(publicNewsType){
    const {filterSelected} = this.state
    if(!!FILTERS[publicNewsType]) {
        return FILTERS[publicNewsType].map(f => (
            <div 
                className={`
                    public__filter-tag
                    ${f.value}
                    ${filterSelected.includes(f.value) ? "is-selected": ""}
                    ${FILTER_ISOLATED[publicNewsType].includes(f.value) ? "no-event": ""}
                `}
                onClick={() => this.handleFilter(f.value)}
            >
                {f.label}
            </div>
        ))
    } else {
        return ""
    }
  }

  @autobind
  private handleFilter(filter){
      const {filterSelected} = this.state
      const {updateObjectCriteria} = this.props
      if(filterSelected.includes(filter)){
        const newfilterSelected = [...filterSelected.filter(x => x !== filter)]
        this.setState({filterSelected: newfilterSelected})
        updateObjectCriteria(this.computeFilters(newfilterSelected))
      } else {
        const newfilterSelected = [...Array.from(new Set([...filterSelected, filter]))]
        this.setState({filterSelected: newfilterSelected})
        updateObjectCriteria(this.computeFilters(newfilterSelected))
      }
  }

  @autobind
  private loadMoreNews(offset){
    const {loadMore, criteria} = this.props
    const newsCriteria = {...criteria}
    newsCriteria.offset = offset
    loadMore(newsCriteria)
  }

  @autobind
  private computeFilters(values: string[]){
    const filter = {} as NewsCriteria;
    const category_actu = [];
    const category_principale = [];
    values.map(f => {
        if(MAPPING_CATEGORY[f] === "actu") {
            category_actu.push(f)
        }
        if(MAPPING_CATEGORY[f] === "principale") {
            category_principale.push(f)
        }
    })
    
    filter.category_actu = category_actu.join(",")
    filter.category_principale = category_principale.join(",")
    return filter
  }

}

const state2props = (state: RootState) => ({
    enterprise: state.accountInfo.enterpriseSelected,
    criteria: state.paginate.news.criteria,
    news: state.paginate.news.entities,
    isFetching: state.paginate.news.isFetching,
    totalSize: state.paginate.news.total_size
});

const dispatch2props = (dispatch: any) => ({
    updateObjectCriteria: (obj: any) => dispatch(actions.updateCriteriaByObject(obj)),
    updateCriteria: (name: string, value: any) => dispatch(actions.updateCriteria(name, value)),
    loadMore: (c: NewsCriteria) => dispatch(fetchMoreNews(c)),
    search: (c: NewsCriteria) => dispatch(fetchNews(c))
});

export default compose(
    withI18n,
    withRouter,
    withGlobalProgress,
    withToast,
    connect(state2props, dispatch2props),
)(PublicNews)



// WEBPACK FOOTER //
// ./src/page/PublicNews/PublicNews.tsx